import { UncontrolledEntity } from './uncontrolled-entity';
import { Entity } from './entity';
import { BaseTransaction } from './base-transaction';

export class UncontrolledTransaction extends BaseTransaction {
  ucSourceLegalEntity: UncontrolledEntity = new UncontrolledEntity();
  ucDestinationLegalEntity: UncontrolledEntity = new UncontrolledEntity();
  sourceLegalEntity: Entity = new Entity();
  destinationLegalEntity: Entity = new Entity();
}
